import { useEffect, useRef } from 'react';
const CHANNEL = 'uxp-auth-channel';
export function broadcastAuthEvent(event) {
    try {
        const bc = new BroadcastChannel(CHANNEL);
        bc.postMessage(event);
        bc.close();
    }
    catch ( /* BroadcastChannel not available */_a) { /* BroadcastChannel not available */ }
}
export function redirectToLogin(withNext = false) {
    const next = withNext
        ? '?next=' + encodeURIComponent(window.location.pathname + window.location.search)
        : '';
    window.location.href = `/view/auth/login${next}`;
}
export function useAuthBroadcastListener(onEvent, skip = false) {
    const onEventRef = useRef(onEvent);
    useEffect(() => { onEventRef.current = onEvent; });
    useEffect(() => {
        if (skip)
            return;
        let bc;
        try {
            bc = new BroadcastChannel(CHANNEL);
            bc.onmessage = (e) => onEventRef.current(e.data);
        }
        catch (_a) { }
        return () => { try {
            bc === null || bc === void 0 ? void 0 : bc.close();
        }
        catch (_a) { } };
    }, [skip]);
}
